/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type UpdateGoalInput = {
    archived?: boolean | null;
    completion?: number | null;
    description?: string | null;
    dueDate?: string | null;
    id: string;
    nextReviewAt?: string | null;
    reviewMode?: ReviewModeInput | null;
    spacedRepetitionLevel?: number | null;
    status?: number | null;
    title?: string | null;
};
export type ReviewModeInput = {
    cycleBegin: ReviewCycleInput;
    cycleGoal?: ReviewCycleInput | null;
    spacedRepetition: boolean;
};
export type ReviewCycleInput = {
    days?: number | null;
    months?: number | null;
};
export type useUpdateGoalMutationVariables = {
    input: UpdateGoalInput;
    first?: number | null;
    after?: string | null;
    last?: number | null;
    before?: string | null;
};
export type useUpdateGoalMutationResponse = {
    readonly updateGoal: {
        readonly " $fragmentRefs": FragmentRefs<"GoalDetailsOverview_goal" | "GoalDetailsReview_goal" | "GoalDetailsSettingsReviewMode_goal">;
    };
};
export type useUpdateGoalMutation = {
    readonly response: useUpdateGoalMutationResponse;
    readonly variables: useUpdateGoalMutationVariables;
};



/*
mutation useUpdateGoalMutation(
  $input: UpdateGoalInput!
  $first: Int
  $after: String
  $last: Int
  $before: String
) {
  updateGoal(input: $input) {
    ...GoalDetailsOverview_goal
    ...GoalDetailsReview_goal
    ...GoalDetailsSettingsReviewMode_goal
    id
  }
}

fragment GoalDetailsCompletion_goal on Goal {
  ...GoalStatusField_goal
}

fragment GoalDetailsCurrentReview_goal on Goal {
  currentReviewAt
}

fragment GoalDetailsDescription_goal on Goal {
  id
  description
}

fragment GoalDetailsDueDate_goal on Goal {
  id
  dueDate
}

fragment GoalDetailsNextReview_goal on Goal {
  nextReviewAt
}

fragment GoalDetailsOverview_goal on Goal {
  type
  archived
  ...GoalDetailsNextReview_goal
  ...GoalDetailsCurrentReview_goal
  ...GoalDetailsCompletion_goal
  ...GoalDetailsReviews_goal
  ...GoalDetailsTitleDescription_goal
  ...GoalDetailsDueDate_goal
}

fragment GoalDetailsReviewCalculationOptions_goal on Goal {
  id
  type
  spacedRepetitionLevel
  status
  reviewMode {
    spacedRepetition
    cycleBegin {
      days
      months
    }
    cycleGoal {
      days
      months
    }
  }
}

fragment GoalDetailsReviewForm_goal on Goal {
  type
  ...GoalDetailsReviewGoalStatus_goal
}

fragment GoalDetailsReviewGoalStatus_goal on Goal {
  type
}

fragment GoalDetailsReviewStatus_goal on Goal {
  nextReviewAt
  type
  archived
  ...GoalDetailsReviewCalculationOptions_goal
}

fragment GoalDetailsReview_goal on Goal {
  id
  type
  status
  completion
  spacedRepetitionLevel
  reviewMode {
    spacedRepetition
    cycleBegin {
      days
      months
    }
    cycleGoal {
      days
      months
    }
  }
  ...GoalDetailsReviewStatus_goal
  ...GoalDetailsReviewForm_goal
  ...GoalDetailsReviews_goal
}

fragment GoalDetailsReviews_goal on Goal {
  ...ReviewCard_goal
  nextReviewAt
  reviews(first: $first, after: $after, last: $last, before: $before) {
    edges {
      node {
        ...ReviewCard_review
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}

fragment GoalDetailsSettingsRepetitionLevel_goal on Goal {
  id
  type
  spacedRepetitionLevel
  reviewMode {
    spacedRepetition
    cycleBegin {
      days
      months
    }
    cycleGoal {
      days
      months
    }
  }
}

fragment GoalDetailsSettingsReviewCycleBegin_goal on Goal {
  id
  spacedRepetitionLevel
  reviewMode {
    spacedRepetition
    cycleBegin {
      days
      months
    }
    cycleGoal {
      days
      months
    }
  }
}

fragment GoalDetailsSettingsReviewCycleGoal_goal on Goal {
  id
  spacedRepetitionLevel
  reviewMode {
    spacedRepetition
    cycleBegin {
      days
      months
    }
    cycleGoal {
      days
      months
    }
  }
}

fragment GoalDetailsSettingsReviewCycleMode_goal on Goal {
  id
  type
  reviewMode {
    spacedRepetition
    cycleBegin {
      days
      months
    }
    cycleGoal {
      days
      months
    }
  }
}

fragment GoalDetailsSettingsReviewCycleNextReview_goal on Goal {
  id
  nextReviewAt
}

fragment GoalDetailsSettingsReviewMode_goal on Goal {
  archived
  type
  reviewMode {
    spacedRepetition
    cycleBegin {
      days
      months
    }
    cycleGoal {
      days
      months
    }
  }
  ...GoalDetailsSettingsReviewCycleMode_goal
  ...GoalDetailsSettingsReviewCycleBegin_goal
  ...GoalDetailsSettingsReviewCycleGoal_goal
  ...GoalDetailsSettingsReviewCycleNextReview_goal
  ...GoalDetailsSettingsRepetitionLevel_goal
}

fragment GoalDetailsTitleDescription_goal on Goal {
  type
  archived
  ...GoalDetailsTitle_goal
  ...GoalDetailsDescription_goal
}

fragment GoalDetailsTitle_goal on Goal {
  id
  title
}

fragment GoalStatusField_goal on Goal {
  type
  status
  completion
  currentReviewAt
}

fragment GoalStatusField_review on Review {
  status
  completion
  createdAt
}

fragment ReviewCardMenuDeleteItem_goal on Goal {
  id
}

fragment ReviewCardMenuDeleteItem_review on Review {
  id
}

fragment ReviewCardMenu_goal on Goal {
  ...ReviewCardMenuDeleteItem_goal
}

fragment ReviewCardMenu_review on Review {
  ...ReviewCardMenuDeleteItem_review
}

fragment ReviewCard_goal on Goal {
  type
  ...GoalStatusField_goal
  ...ReviewCardMenu_goal
}

fragment ReviewCard_review on Review {
  id
  completion
  comment
  automatedReview
  createdAt
  ...GoalStatusField_review
  ...ReviewCardMenu_review
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v5 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completion",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  }
],
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "days",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "months",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateGoalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "updateGoal",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GoalDetailsOverview_goal"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GoalDetailsReview_goal"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GoalDetailsSettingsReviewMode_goal"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateGoalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "updateGoal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archived",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nextReviewAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentReviewAt",
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "ReviewConnection",
            "kind": "LinkedField",
            "name": "reviews",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReviewEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Review",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "comment",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "automatedReview",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "GoalDetailsReviews_reviews",
            "kind": "LinkedHandle",
            "name": "reviews"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dueDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "spacedRepetitionLevel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ReviewMode",
            "kind": "LinkedField",
            "name": "reviewMode",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "spacedRepetition",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ReviewCycle",
                "kind": "LinkedField",
                "name": "cycleBegin",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ReviewCycle",
                "kind": "LinkedField",
                "name": "cycleGoal",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "63fd382632f81e77e9457fb5e02a8514",
    "id": null,
    "metadata": {},
    "name": "useUpdateGoalMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateGoalMutation(\n  $input: UpdateGoalInput!\n  $first: Int\n  $after: String\n  $last: Int\n  $before: String\n) {\n  updateGoal(input: $input) {\n    ...GoalDetailsOverview_goal\n    ...GoalDetailsReview_goal\n    ...GoalDetailsSettingsReviewMode_goal\n    id\n  }\n}\n\nfragment GoalDetailsCompletion_goal on Goal {\n  ...GoalStatusField_goal\n}\n\nfragment GoalDetailsCurrentReview_goal on Goal {\n  currentReviewAt\n}\n\nfragment GoalDetailsDescription_goal on Goal {\n  id\n  description\n}\n\nfragment GoalDetailsDueDate_goal on Goal {\n  id\n  dueDate\n}\n\nfragment GoalDetailsNextReview_goal on Goal {\n  nextReviewAt\n}\n\nfragment GoalDetailsOverview_goal on Goal {\n  type\n  archived\n  ...GoalDetailsNextReview_goal\n  ...GoalDetailsCurrentReview_goal\n  ...GoalDetailsCompletion_goal\n  ...GoalDetailsReviews_goal\n  ...GoalDetailsTitleDescription_goal\n  ...GoalDetailsDueDate_goal\n}\n\nfragment GoalDetailsReviewCalculationOptions_goal on Goal {\n  id\n  type\n  spacedRepetitionLevel\n  status\n  reviewMode {\n    spacedRepetition\n    cycleBegin {\n      days\n      months\n    }\n    cycleGoal {\n      days\n      months\n    }\n  }\n}\n\nfragment GoalDetailsReviewForm_goal on Goal {\n  type\n  ...GoalDetailsReviewGoalStatus_goal\n}\n\nfragment GoalDetailsReviewGoalStatus_goal on Goal {\n  type\n}\n\nfragment GoalDetailsReviewStatus_goal on Goal {\n  nextReviewAt\n  type\n  archived\n  ...GoalDetailsReviewCalculationOptions_goal\n}\n\nfragment GoalDetailsReview_goal on Goal {\n  id\n  type\n  status\n  completion\n  spacedRepetitionLevel\n  reviewMode {\n    spacedRepetition\n    cycleBegin {\n      days\n      months\n    }\n    cycleGoal {\n      days\n      months\n    }\n  }\n  ...GoalDetailsReviewStatus_goal\n  ...GoalDetailsReviewForm_goal\n  ...GoalDetailsReviews_goal\n}\n\nfragment GoalDetailsReviews_goal on Goal {\n  ...ReviewCard_goal\n  nextReviewAt\n  reviews(first: $first, after: $after, last: $last, before: $before) {\n    edges {\n      node {\n        ...ReviewCard_review\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment GoalDetailsSettingsRepetitionLevel_goal on Goal {\n  id\n  type\n  spacedRepetitionLevel\n  reviewMode {\n    spacedRepetition\n    cycleBegin {\n      days\n      months\n    }\n    cycleGoal {\n      days\n      months\n    }\n  }\n}\n\nfragment GoalDetailsSettingsReviewCycleBegin_goal on Goal {\n  id\n  spacedRepetitionLevel\n  reviewMode {\n    spacedRepetition\n    cycleBegin {\n      days\n      months\n    }\n    cycleGoal {\n      days\n      months\n    }\n  }\n}\n\nfragment GoalDetailsSettingsReviewCycleGoal_goal on Goal {\n  id\n  spacedRepetitionLevel\n  reviewMode {\n    spacedRepetition\n    cycleBegin {\n      days\n      months\n    }\n    cycleGoal {\n      days\n      months\n    }\n  }\n}\n\nfragment GoalDetailsSettingsReviewCycleMode_goal on Goal {\n  id\n  type\n  reviewMode {\n    spacedRepetition\n    cycleBegin {\n      days\n      months\n    }\n    cycleGoal {\n      days\n      months\n    }\n  }\n}\n\nfragment GoalDetailsSettingsReviewCycleNextReview_goal on Goal {\n  id\n  nextReviewAt\n}\n\nfragment GoalDetailsSettingsReviewMode_goal on Goal {\n  archived\n  type\n  reviewMode {\n    spacedRepetition\n    cycleBegin {\n      days\n      months\n    }\n    cycleGoal {\n      days\n      months\n    }\n  }\n  ...GoalDetailsSettingsReviewCycleMode_goal\n  ...GoalDetailsSettingsReviewCycleBegin_goal\n  ...GoalDetailsSettingsReviewCycleGoal_goal\n  ...GoalDetailsSettingsReviewCycleNextReview_goal\n  ...GoalDetailsSettingsRepetitionLevel_goal\n}\n\nfragment GoalDetailsTitleDescription_goal on Goal {\n  type\n  archived\n  ...GoalDetailsTitle_goal\n  ...GoalDetailsDescription_goal\n}\n\nfragment GoalDetailsTitle_goal on Goal {\n  id\n  title\n}\n\nfragment GoalStatusField_goal on Goal {\n  type\n  status\n  completion\n  currentReviewAt\n}\n\nfragment GoalStatusField_review on Review {\n  status\n  completion\n  createdAt\n}\n\nfragment ReviewCardMenuDeleteItem_goal on Goal {\n  id\n}\n\nfragment ReviewCardMenuDeleteItem_review on Review {\n  id\n}\n\nfragment ReviewCardMenu_goal on Goal {\n  ...ReviewCardMenuDeleteItem_goal\n}\n\nfragment ReviewCardMenu_review on Review {\n  ...ReviewCardMenuDeleteItem_review\n}\n\nfragment ReviewCard_goal on Goal {\n  type\n  ...GoalStatusField_goal\n  ...ReviewCardMenu_goal\n}\n\nfragment ReviewCard_review on Review {\n  id\n  completion\n  comment\n  automatedReview\n  createdAt\n  ...GoalStatusField_review\n  ...ReviewCardMenu_review\n}\n"
  }
};
})();
(node as any).hash = '9b2a0a5bbef72e0d28c606ab1875a76c';
export default node;
